export const PARTNERS_COVERAGE_TABLE_KEYS = [
  'topAccounts',
  'powerElite',
  'power',
  'synergy',
] as const
export type TPartnersCoverageTableKey = (typeof PARTNERS_COVERAGE_TABLE_KEYS)[number]

export const PARTNERS_COVERAGE_COLUMN_KEYS = [
  'all',
  'mdf',
  'ps',
  'pr',
  'poly',
  'mps',
  'hps',
  'acs',
  'videoVoice',
  'aiPlan',
  'partnersPbm',
] as const
export type TPartnersCoverageColumnKey = (typeof PARTNERS_COVERAGE_COLUMN_KEYS)[number]

export const PARTNERS_COVERAGE_ROW_ORDER = [
  'Total Partners count',
  '# Partners with plan',
  '% of partners with plan',
  'Amplify Coverage',
] as const
export type TPartnersCoverageRowLabel = (typeof PARTNERS_COVERAGE_ROW_ORDER)[number]

/** Rows rendered as percentages, the rest are integer counts. */
export const PARTNERS_COVERAGE_PERCENT_ROW_LABELS: readonly TPartnersCoverageRowLabel[] = [
  '% of partners with plan',
  'Amplify Coverage',
]

/** `partnersPbm` of this row is rendered as a ratio (for example `2.5` or `14`). */
export const PARTNERS_COVERAGE_TOTAL_PARTNERS_ROW_LABEL: TPartnersCoverageRowLabel =
  'Total Partners count'

/** Table titles as they are printed on the deck slide, next to the partner pyramid. */
export const PARTNERS_COVERAGE_TABLE_TITLES: Record<TPartnersCoverageTableKey, string> = {
  topAccounts: 'Top A/Cs',
  powerElite: 'Power Elite',
  power: 'Power',
  synergy: 'Synergy',
}

/** Column titles as they are printed on the deck slide. */
export const PARTNERS_COVERAGE_COLUMN_TITLES: Record<TPartnersCoverageColumnKey, string> = {
  all: 'All',
  mdf: 'MDF',
  ps: 'PS',
  pr: 'PR',
  poly: 'Poly',
  mps: 'MPS',
  hps: 'HPS',
  acs: 'ACS',
  videoVoice: 'Video Voice',
  aiPlan: 'AI Plan',
  partnersPbm: 'Partners /PBM',
}
